/* Store search engine — shared by the header search, the Replacement Parts Finder and the search page.
   Data comes live from the store:
     /collections/all?view=pf-meta        models, brands, equipment types, collection names
     /collections/all?view=pf-index&page=N  every published product, 250 per page
   Cached in the shopper's browser for a day (refreshed in the background after an hour) so repeat searches are instant.
   Until the catalog has loaded, the header search shows Shopify's predictive-search results so there is never a wait. */
(function () {
  if (window.PFSearch) return;

  var CACHE_KEY = 'pfs:v7', TTL = 24 * 3600 * 1000, FRESH = 60 * 60 * 1000;
  var norm = function (s) { return (s || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  var STOP = { for: 1, my: 1, the: 1, a: 1, an: 1, of: 1, and: 1, to: 1, on: 1, in: 1, with: 1, replacement: 1, part: 1, parts: 1, pool: 1, i: 1, need: 1, want: 1, looking: 1, new: 1, buy: 1, is: 1, it: 1, this: 1, that: 1, what: 1, which: 1, do: 1, you: 1, have: 1, me: 1, find: 1, get: 1, please: 1, spa: 1, swimming: 1, our: 1, your: 1, from: 1, fits: 1, fit: 1, compatible: 1 };
  var SYN = { system: ['chlorinator', 'generator'], systems: ['chlorinator', 'generator'], chlorinator: ['salt system', 'generator'], generator: ['chlorinator'], tire: ['wheel', 'tyre'], tyre: ['tire', 'wheel'], wheel: ['tire'], wheels: ['tires', 'tire'], tires: ['wheels', 'wheel'], lid: ['cover'], cover: ['lid'], oring: ['gasket', 'o-ring'], orings: ['gasket', 'oring'], gasket: ['oring'], basket: ['strainer'], strainer: ['basket'], latch: ['lock', 'clip', 'catch'], gear: ['drive', 'turbine'], gears: ['drive', 'turbine'], screw: ['bolt'], bolt: ['screw'], bulb: ['lamp', 'light'], lamp: ['bulb'], hose: ['tube'], bag: ['debris bag', 'filter bag'], cell: ['turbocell', 't-cell', 'salt cell'], board: ['pcb', 'control board'], igniter: ['ignitor'], ignitor: ['igniter'], knob: ['handle'], diaphram: ['diaphragm'], impellor: ['impeller'], chlorine: ['chlorinating', 'shock'], tabs: ['tablets'], tablets: ['tabs'], brush: ['brushes'], net: ['skimmer', 'rake'], rake: ['net'], cartridge: ['element'], element: ['cartridge'], motor: ['motor'], vac: ['vacuum'], vacuum: ['vac'], robot: ['robotic'], robotic: ['robot'], heater: ['heater'], seal: ['seal', 'shaft seal'], oring_: [] };
  var GENERIC = { pump: 1, pumps: 1, filter: 1, filters: 1, heater: 1, heaters: 1, cleaner: 1, cleaners: 1, light: 1, lights: 1, skimmer: 1, skimmers: 1, heat: 1, series: 1, variable: 1, speed: 1, single: 1, inground: 1, above: 1, ground: 1, cartridge: 1, sand: 1, pressure: 1, suction: 1, pool: 1, spa: 1, btu: 1, sqft: 1, the: 1, and: 1, plus: 1, pro: 1, cool: 1, chill: 1, wheel: 1, drive: 1, color: 1, led: 1, incandescent: 1, gunite: 1, mount: 1, top: 1, side: 1, architectural: 1, universal: 1, digital: 1, low: 1, nox: 1, asme: 1, booster: 1, aboveground: 1 };

  function tolerance(n) { return n >= 8 ? 3 : n >= 6 ? 2 : n >= 4 ? 1 : 0; }
  function synonyms(tk) { var out = [tk], tn = norm(tk); if (SYN[tn]) out = out.concat(SYN[tn]); if (tn.length > 3 && tn.slice(-1) === 's' && SYN[tn.slice(0, -1)]) out = out.concat(SYN[tn.slice(0, -1)]); return out; }
  function editDist(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var prev = [], cur, prev2 = null, i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      cur = [i]; var rowMin = i;
      for (j = 1; j <= b.length; j++) {
        var cost = a[i - 1] === b[j - 1] ? 0 : 1;
        var v = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost);
        if (prev2 && i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) v = Math.min(v, prev2[j - 2] + 1);
        cur[j] = v; if (v < rowMin) rowMin = v;
      }
      if (rowMin > max) return max + 1;
      prev2 = prev; prev = cur;
    }
    return prev[b.length];
  }

  /* words that name a whole piece of equipment; a query made only of these, brands,
     model names and sizes means the shopper wants the unit itself, not a part for it */
  var KIND = { pump: 1, pumps: 1, filter: 1, filters: 1, heater: 1, heaters: 1, cleaner: 1, cleaners: 1, robot: 1, robotic: 1, vacuum: 1, salt: 1, system: 1, systems: 1, chlorinator: 1, chlorinators: 1, generator: 1, skimmer: 1, skimmers: 1, light: 1, lights: 1, heatpump: 1, automation: 1, controller: 1, ozonator: 1, feeder: 1, booster: 1 };
  var EQ_FILL = { hp: 1, thp: 1, btu: 1, btus: 1, sq: 1, ft: 1, sqft: 1, gallon: 1, gallons: 1, gal: 1, k: 1, h: 1, natural: 1, gas: 1, propane: 1, de: 1, complete: 1, whole: 1, unit: 1, full: 1, equipment: 1, inground: 1, 'in-ground': 1, above: 1, ground: 1, aboveground: 1, residential: 1, commercial: 1 };

  /* ---------------- data ---------------- */
  var S = { products: [], models: [], brands: {}, brandList: [], types: {}, typeList: [], collections: [], colById: {}, diagrams: {}, vocab: {}, vocabByLen: {}, cdn: '', complete: false };
  var listeners = [], loading = null;

  function prepProduct(r) {
    var skus = r[4] || [], text = [r[2], r[1], r[3]].join(' ');
    return { h: r[0], t: r[1], v: r[2], ty: r[3], skus: skus, price: r[5], cmp: r[6], img: r[7], av: r[8], stock: r[9], flags: r[10], c: r[11] || [], vid: r[12], vc: r[13],
      tN: norm(r[1]), vN: norm(r[2]), skusN: skus.map(norm), low: text.toLowerCase(), lowN: norm(text),
      words: text.toLowerCase().split(/[^a-z0-9]+/).filter(function (w) { return w.length > 1; }) };
  }
  function addVocab(words) {
    words.forEach(function (w) {
      if (w.length < 3 || /\d/.test(w)) return;
      if (!S.vocab[w]) { S.vocab[w] = 0; (S.vocabByLen[w.length] = S.vocabByLen[w.length] || []).push(w); }
      S.vocab[w]++;
    });
  }
  function setMeta(meta) {
    S.diagrams = {}; (meta.diagrams || []).forEach(function (d) { if (d.ch) S.diagrams[d.ch] = d; });
    S.typeList = meta.types || []; S.types = {}; S.typeList.forEach(function (t) { S.types[t.h] = t; });
    S.brandList = meta.brands || []; S.brands = {}; S.brandList.forEach(function (b) { S.brands[b.h] = b; });
    S.collections = (meta.collections || []).filter(function (c) { return c.h; });
    S.colById = {}; S.collections.forEach(function (c) { S.colById[c.id] = c; c.nN = norm(c.n); c.low = c.n.toLowerCase(); });
    S.models = (meta.models || []).filter(function (m) { return m.u && S.brands[m.b] && S.types[m.t]; });
    S.models.forEach(function (m) {
      var b = S.brands[m.b], t = S.types[m.t];
      m.bn = b.n; m.tn = t.n; m.label = b.n + ' ' + m.n;
      var words = [b.n, m.n, m.d, m.no, t.n, (m.k || '').replace(/\n/g, ' ')].join(' ');
      m.hay = words.toLowerCase(); m.hayN = norm(words);
      m.keys = [m.no].concat((m.k || '').split('\n')).map(norm).filter(Boolean);
      m.nameN = norm(m.n); m.brandN = norm(b.n);
      var nw = {};
      [m.n].concat((m.k || '').split('\n')).forEach(function (phrase) {
        var pn = norm(phrase); if (pn.length >= 3) nw[pn] = 1;
        phrase.toLowerCase().split(/[^a-z0-9]+/).forEach(function (w) { if (w.length >= 3 && !GENERIC[w]) nw[w] = 1; });
      });
      if (m.no) nw[norm(m.no)] = 1;
      m.nameWords = Object.keys(nw);
      m.dpSet = {}; var dg = S.diagrams[m.ch]; if (dg) { (dg.p || []).forEach(function (h) { m.dpSet[h] = 1; }); if (!m.i && dg.i) m.i = dg.i; }
      addVocab(words.toLowerCase().split(/[^a-z0-9]+/));
    });
  }
  function addRows(rows) {
    rows.forEach(function (r) { var p = prepProduct(r); S.products.push(p); addVocab(p.words); });
  }
  function emit() { listeners.forEach(function (fn) { try { fn(S); } catch (e) {} }); }
  function getJSON(url) { return fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (t) { return JSON.parse(t); }); }

  function readCache() {
    try { var c = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null'); if (c && Date.now() - c.t < TTL && c.rows && c.rows.length) return c; } catch (e) {}
    return null;
  }
  function writeCache(meta, rows) {
    try { localStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), meta: meta, rows: rows, cdn: S.cdn })); } catch (e) {}
  }

  function reset() { S.products = []; S.vocab = {}; S.vocabByLen = {}; }
  function load() {
    if (loading) return loading;
    var cached = readCache();
    if (cached) {
      S.cdn = cached.cdn || ''; setMeta(cached.meta); addRows(cached.rows); S.complete = true;
      loading = Promise.resolve(S); emit();
      /* older than an hour: quietly rebuild from the store so prices and stock stay current */
      if (Date.now() - cached.t > FRESH) setTimeout(function () { fetchAll().then(function (d) { reset(); S.cdn = d.cdn; setMeta(d.meta); addRows(d.rows); writeCache(d.meta, d.rows); emit(); }).catch(function () {}); }, 4000);
      return loading;
    }
    loading = fetchAll(true).then(function (d) { S.complete = true; writeCache(d.meta, d.rows); emit(); return S; })
      .catch(function (e) { loading = null; throw e; });
    return loading;
  }
  /* Download the whole catalog. live=true feeds rows into the state as pages land (first visit);
     live=false collects silently for a background refresh. */
  function fetchAll(live) {
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'collections/all';
    var allRows = [], meta = null;
    var diaP = getJSON(base + '?view=pf-dia0').then(function (f) {
      var parts = Math.ceil((f.total || 0) / 40), more = [];
      for (var i = 1; i < parts; i++) more.push(getJSON(base + '?view=pf-dia' + i).catch(function () { return { d: [] }; }));
      return Promise.all(more).then(function (ps) { ps.forEach(function (x) { f.d = f.d.concat(x.d || []); }); return f; });
    }).catch(function () { return { d: [] }; });
    var metaP = getJSON(base + '?view=pf-meta').then(function (m) {
      meta = m;
      if (m.cpages > 1) {
        var more = []; for (var i = 2; i <= m.cpages; i++) more.push(getJSON(base + '?view=pf-meta&page=' + i));
        return Promise.all(more).then(function (ps) { ps.forEach(function (x) { meta.collections = meta.collections.concat(x.collections || []); }); });
      }
    }).then(function () { return diaP; }).then(function (dd) { meta.diagrams = dd.d || []; if (live) { setMeta(meta); emit(); } });
    var cdn = '';
    var idxP = getJSON(base + '?view=pf-index&page=1').then(function (first) {
      cdn = first.cdn || ''; if (live) { S.cdn = cdn; addRows(first.p); emit(); } allRows = allRows.concat(first.p);
      var pages = [], i;
      for (i = 2; i <= first.pages; i++) pages.push(i);
      /* fetch the rest a few at a time and refresh results as each page lands */
      return new Promise(function (resolve) {
        var inFlight = 0, idx = 0;
        function next() {
          if (idx >= pages.length && inFlight === 0) return resolve();
          while (inFlight < 5 && idx < pages.length) {
            var pg = pages[idx++]; inFlight++;
            getJSON(base + '?view=pf-index&page=' + pg).then(function (d) { if (live) { addRows(d.p); emit(); } allRows = allRows.concat(d.p); })
              .catch(function () {}).then(function () { inFlight--; next(); });
          }
        }
        next();
      });
    });
    return Promise.all([metaP, idxP]).then(function () { return { meta: meta, rows: allRows, cdn: cdn }; });
  }

  /* Instant results from Shopify's predictive search, used until the full catalog has loaded. */
  var sugCache = {};
  function suggest(q, limit) {
    q = (q || '').trim(); if (!q) return Promise.resolve([]);
    var key = q.toLowerCase() + '|' + (limit || 7);
    if (sugCache[key]) return sugCache[key];
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/');
    var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=' + (limit || 7) + '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,vendor,variants.title,variants.sku';
    return sugCache[key] = getJSON(url).then(function (d) {
      var list = ((d.resources || {}).results || {}).products || [];
      return list.map(function (p) {
        var skus = (p.variants || []).map(function (v) { return v.sku; }).filter(Boolean);
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
        var flags = (p.tags || []).some(function (t) { return /^in[ -]?store only$/i.test(t); }) ? 1 : 0;
        return { h: p.handle, t: p.title, v: p.vendor || '', ty: p.type || '', skus: skus, price: Number(p.price) || 0, cmp: Number(p.compare_at_price) || 0, imgUrl: img, av: !!p.available, stock: -1, flags: flags, c: [], vid: null, vc: (p.variants || []).length, suggested: true };
      });
    }).catch(function () { delete sugCache[key]; return []; });
  }

  /* ---------------- spelling ---------------- */
  function correct(tn) {
    if (tn.length < 4 || /\d/.test(tn) || S.vocab[tn]) return tn;
    var tol = tn.length >= 8 ? 2 : 1, best = null, bestD = 9, bestF = 0, L;
    for (L = tn.length - tol; L <= tn.length + tol; L++) {
      var list = S.vocabByLen[L]; if (!list) continue;
      for (var i = 0; i < list.length; i++) {
        var w = list[i]; if (w[0] !== tn[0] && tn.length < 7) continue;
        var d = editDist(tn, w, tol);
        if (d <= tol && (d < bestD || (d === bestD && S.vocab[w] > bestF))) { best = w; bestD = d; bestF = S.vocab[w]; }
      }
    }
    return best || tn;
  }
  function anyProductHas(tn) {
    for (var i = 0; i < S.products.length; i++) if (S.products[i].lowN.indexOf(tn) > -1) return true;
    for (i = 0; i < S.models.length; i++) if (S.models[i].hayN.indexOf(tn) > -1) return true;
    return false;
  }

  /* ---------------- scoring ---------------- */
  function fuzzyWord(tn, words) {
    if (/\d/.test(tn)) {
      if (tn.length < 5) return 0;
      var pre = tn.slice(0, Math.ceil(tn.length * 0.7));
      for (var j = 0; j < words.length; j++) if (words[j].indexOf(pre) === 0) return 0.5;
      return 0;
    }
    var max = tn.length >= 8 ? 2 : (tn.length >= 4 ? 1 : 0);
    if (!max) return 0;
    for (var i = 0; i < words.length; i++) {
      var w = words[i];
      if (w.length < tn.length - max) continue;
      if (Math.abs(w.length - tn.length) <= max && editDist(tn, w, max) <= max) return 1;
      if (w.length > tn.length + 1 && editDist(tn, w.slice(0, tn.length), max) <= max) return 0.6;
    }
    return 0;
  }
  function scoreProduct(pr, qn, tokens) {
    var s = 0, i, k;
    if (qn.length >= 3) {
      for (i = 0; i < pr.skusN.length; i++) {
        var sk = pr.skusN[i];
        if (sk === qn) s = Math.max(s, 1000);
        else {
          k = sk.indexOf(qn);
          if (k === 0) s = Math.max(s, (/^\d+$/.test(qn) && qn.length < 5 && sk.length > qn.length + 3) ? 640 : 800);
          else if (k > 0) s = Math.max(s, 600 - Math.min(k, 20) * 4 + (/[a-z]/.test(sk[k - 1]) ? 60 : 0));
        }
      }
      if (pr.tN.indexOf(qn) > -1) s = Math.max(s, 450);
      else if (pr.lowN.indexOf(qn) > -1) s = Math.max(s, 400);
    }
    var tsum = 0;
    for (i = 0; i < tokens.length; i++) {
      var tk = tokens[i], tn = norm(tk);
      if (!tn) continue;
      var hit = 0, alts = synonyms(tk);
      for (k = 0; k < alts.length && !hit; k++) { var an = norm(alts[k]); if (pr.low.indexOf(alts[k].toLowerCase()) > -1 || pr.lowN.indexOf(an) > -1) hit = k ? 0.8 : 1; }
      if (!hit && tn.length >= 3) { for (k = 0; k < pr.skusN.length; k++) if (pr.skusN[k].indexOf(tn) > -1) { hit = 1; break; } }
      if (!hit) hit = fuzzyWord(tn, pr.words);
      if (!hit) { tsum = -1; break; }
      tsum += hit;
      if (pr.tN.indexOf(tn) > -1) tsum += 0.3;
      for (k = 0; k < pr.words.length; k++) if (pr.words[k].indexOf(tn) === 0) { tsum += 0.5; break; }
    }
    if (tsum < 0) return s >= 600 ? s : 0;
    s += 100 + tsum * 40;
    if (pr.vN && qn.indexOf(pr.vN) === 0) s += 30;
    if (pr.av) s += 12;
    if (pr.flags & 1) s -= 4;
    return s;
  }
  function searchProducts(qn, tokens, boost, filterFn) {
    var out = [], i, j;
    for (i = 0; i < S.products.length; i++) {
      var pr = S.products[i];
      if (filterFn && !filterFn(pr)) continue;
      var inCol = false;
      if (boost) {
        if (boost.h && boost.h[pr.h]) inCol = 2;
        else for (j = 0; j < pr.c.length; j++) if (boost.ids[pr.c[j]]) { inCol = true; break; }
        /* a part "for" the model names it in its title, e.g. "Latch Kit | For TracVac Cleaners" */
        if (!inCol) for (j = 0; j < boost.words.length; j++) if (pr.tN.indexOf(boost.words[j]) > -1) { inCol = true; break; }
      }
      var sc = tokens.length ? scoreProduct(pr, qn, tokens) : (inCol ? 100 + (pr.av ? 8 : 0) : 0);
      if (sc > 0) out.push({ p: pr, s: sc + (inCol === 2 ? 400 : inCol ? 250 : 0) });
    }
    out.sort(function (a, b) { return b.s - a.s || a.p.t.localeCompare(b.p.t); });
    return out.map(function (x) { return x.p; });
  }
  function scoreModel(m, raw) {
    var tokens = raw.toLowerCase().split(/\s+/).filter(Boolean), qn = norm(raw);
    if (!qn) return 0;
    var s = 0;
    for (var i = 0; i < tokens.length; i++) {
      var tn = norm(tokens[i]); if (!tn) continue;
      if (/^\d+$/.test(tn) && tn.length < 4) { if (!m.keys.some(function (k) { return k.indexOf(tn) === 0; })) return 0; }
      else if (tn.length < 4 ? (' ' + m.hay.replace(/[^a-z0-9]+/g, ' ')).indexOf(' ' + tn) === -1 : (m.hay.indexOf(tokens[i]) === -1 && m.hayN.indexOf(tn) === -1)) return 0;
    }
    if (m.keys.indexOf(qn) > -1) s += 100; else if (m.keys.some(function (k) { return k.indexOf(qn) === 0; })) s += 60;
    if (m.nameN === qn) s += 50; else if (m.nameN.indexOf(qn) === 0) s += 35; else if (norm(m.label).indexOf(qn) > -1) s += 25;
    if (m.hayN.indexOf(qn) > -1) s += 10;
    return s + (m.p ? 5 : 0) + 1;
  }
  function detectModels(tokens) {
    var found = [], askedBrand = null;
    tokens.forEach(function (tk) { var tn = norm(tk); S.brandList.forEach(function (b) { if (norm(b.n) === tn) askedBrand = b.h; }); });
    S.models.forEach(function (m) {
      if (askedBrand && m.b !== askedBrand) return;
      var used = {}, hitsN = 0, brandHit = false;
      tokens.forEach(function (tk, i) {
        var tn = norm(tk); if (tn.length < 3) return;
        if (tn === m.brandN || (tn.length >= 5 && editDist(tn, m.brandN, 1) <= 1)) { brandHit = true; used[i] = 1; return; }
        for (var k = 0; k < m.nameWords.length; k++) {
          var w = m.nameWords[k];
          if (w === tn) { hitsN += 2; used[i] = 1; return; }
          if (w.indexOf(tn) === 0 && tn.length >= 4) { hitsN += 1.5; used[i] = 1; return; }
          var tol = /\d/.test(tn) || GENERIC[tn] || KIND[tn] ? 0 : tolerance(Math.max(tn.length, w.length));
          if (tol && Math.abs(w.length - tn.length) <= tol && editDist(tn, w, tol) <= tol) { hitsN += 1; used[i] = 1; return; }
        }
      });
      for (var i = 0; i + 1 < tokens.length; i++) {
        var joined = norm(tokens[i] + tokens[i + 1]); if (joined.length < 5) continue;
        for (var k = 0; k < m.nameWords.length; k++) {
          var w = m.nameWords[k], tol = /\d/.test(joined) ? 0 : tolerance(Math.max(joined.length, w.length));
          if (w === joined || (tol && Math.abs(w.length - joined.length) <= tol && editDist(joined, w, tol) <= tol)) { hitsN += 2; used[i] = 1; used[i + 1] = 1; break; }
        }
      }
      if (hitsN >= 1) found.push({ m: m, s: hitsN * 10 + (brandHit ? 5 : 0) + (m.p ? 1 : 0), used: used });
    });
    found.sort(function (a, b) { return b.s - a.s; });
    return found;
  }
  function equipmentIntent(tokens) {
    var kind = false;
    for (var i = 0; i < tokens.length; i++) {
      var raw = tokens[i].toLowerCase(), tn = norm(raw);
      if (!tn) continue;
      if (KIND[tn] || KIND[raw]) { kind = true; continue; }
      if (GENERIC[tn] || EQ_FILL[tn] || EQ_FILL[raw] || /^\d[\d.,]*(k|hp|thp|btu|ft|sqft)?$/.test(tn)) continue;
      if (S.brandList.some(function (b) { return norm(b.n) === tn; })) continue;
      if (S.models.some(function (m) { return m.nameWords.indexOf(tn) > -1 || m.brandN === tn; })) continue;
      return false;
    }
    return kind;
  }
  function searchCollections(tokens) {
    if (!tokens.length) return [];
    return S.collections.filter(function (c) {
      if (/^replacement parts diagram/i.test(c.n) || / diagram/i.test(c.n)) return false;
      return tokens.every(function (tk) {
        var tn = norm(tk); if (!tn) return true;
        if (c.nN.indexOf(tn) > -1) return true;
        var alts = synonyms(tk); for (var i = 1; i < alts.length; i++) if (c.nN.indexOf(norm(alts[i])) > -1) return true;
        return fuzzyWord(tn, c.low.split(/[^a-z0-9]+/)) > 0;
      });
    }).sort(function (a, b) { return a.n.length - b.n.length || b.pc - a.pc; }).slice(0, 4);
  }

  /* ---------------- query ---------------- */
  function query(raw, opts) {
    opts = opts || {};
    raw = (raw || '').trim();
    var res = { raw: raw, tokens: [], corrected: null, models: [], collections: [], products: [], total: 0, label: '' };
    if (!raw) return res;
    var allTokens = raw.split(/\s+/).filter(Boolean);
    var tokens = allTokens.filter(function (t) { return !STOP[t.toLowerCase()]; });
    if (!tokens.length) tokens = allTokens;
    /* spelling: fix words nothing in the store contains */
    if (S.products.length) {
      var changed = false;
      tokens = tokens.map(function (t) {
        var tn = norm(t); if (tn.length < 4 || /\d/.test(tn) || anyProductHas(tn)) return t;
        var c = correct(tn); if (c !== tn) { changed = true; return c; } return t;
      });
      if (changed) res.corrected = tokens.join(' ');
    }
    res.tokens = tokens;
    var qn = norm(tokens.join(' '));
    var modelHits = S.models.map(function (m) { return { m: m, s: scoreModel(m, tokens.join(' ')) }; }).filter(function (x) { return x.s > 0; })
      .sort(function (a, b) { return b.s - a.s || a.m.label.localeCompare(b.m.label); }).slice(0, opts.modelLimit || 5).map(function (x) { return x.m; });
    var det = detectModels(tokens), boost = null, partTokens = tokens;
    if (det.length) {
      var best = det[0], rest = tokens.filter(function (t, i) { return !best.used[i]; });
      if (rest.length < tokens.length) {
        boost = { ids: {}, words: [], h: {} };
        det.filter(function (d) { return d.s >= best.s - 5; }).slice(0, 6).forEach(function (d) {
          if (d.m.cid) boost.ids[d.m.cid] = 1;
          for (var dh in d.m.dpSet) boost.h[dh] = 1;
          d.m.nameWords.forEach(function (w) { if (w.length >= 4 && !/^\d+$/.test(w) && boost.words.indexOf(w) === -1) boost.words.push(w); });
          if (modelHits.indexOf(d.m) === -1) modelHits.push(d.m);
        });
        modelHits = modelHits.slice(0, opts.modelLimit || 5);
        partTokens = rest.length ? rest : tokens;
      }
    }
    var eqWanted = equipmentIntent(tokens);
    var list = searchProducts(qn, partTokens, boost, opts.filter);
    if (eqWanted) {
      /* complete units that match every word go first, ahead of parts for them */
      var units = searchProducts(qn, tokens, null, function (pr) { return (pr.flags & 4) && (!opts.filter || opts.filter(pr)); });
      units = units.filter(function (u) { return !/ for /i.test(u.t); }).concat(units.filter(function (u) { return / for /i.test(u.t); }));
      if (units.length) {
        var seen = {}; units.forEach(function (u) { seen[u.h] = 1; });
        list = units.concat(list.filter(function (x) { return !seen[x.h]; }));
        res.equipment = units.length;
      }
    }
    if (!list.length && partTokens !== tokens) list = searchProducts(qn, tokens, null, opts.filter);
    if (!list.length && boost) { list = searchProducts('', [], boost, opts.filter); if (list.length) res.label = 'model'; }
    if (!list.length && tokens.length > 1) {
      var order = tokens.map(function (t, i) { return i; }).sort(function (a, b) { return tokens[a].length - tokens[b].length; });
      for (var oi = 0; oi < order.length && oi < 4; oi++) {
        var fewer = tokens.filter(function (t, i) { return i !== order[oi]; });
        var alt = searchProducts(norm(fewer.join(' ')), fewer, boost, opts.filter);
        if (alt.length) { list = alt; res.label = 'dropped'; res.dropped = tokens[order[oi]]; res.kept = fewer.join(' '); break; }
      }
    }
    res.models = modelHits;
    res.bestModel = det.length ? det[0].m : null;
    res.collections = searchCollections(tokens);
    res.all = list;
    res.total = list.length;
    res.products = list.slice(0, opts.limit || 8);
    return res;
  }

  function highlight(text, tokens) {
    var out = esc(text);
    (tokens || []).forEach(function (tk) {
      var tn = norm(tk); if (tn.length < 2 || STOP[tn]) return;
      var pat = tn.split('').map(function (c) { return c.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }).join('[\\s\\-._/]*');
      out = out.replace(new RegExp('(' + pat + ')(?![^<]*>)', 'ig'), '<mark>$1</mark>');
    });
    return out;
  }
  function imageUrl(p, w) { if (p.imgUrl) return p.imgUrl + (p.imgUrl.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 200); return p.img ? S.cdn + p.img + '?width=' + (w || 200) : ''; }
  function money(n) { return '$' + Number(n || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function cleanTitle(p) { var t = p.t, s = p.skus[0]; if (s && t.slice(-(s.length + 3)) === ' | ' + s) t = t.slice(0, -(s.length + 3)); return t; }
  function stockState(p) {
    if (p.flags & 1) return { key: 'instore', text: 'In store only' };
    if (p.av && (p.flags & 8)) return { key: 'in', text: 'Available' };
    if (!p.av) return { key: 'out', text: 'Sold out' };
    if (p.stock > 0 && p.stock <= (window.PFSearchLowStock || 3)) return { key: 'low', text: 'Only ' + p.stock + ' left' };
    if (p.stock === 0 && (p.flags & 2)) return { key: 'backorder', text: 'Ships soon' };
    return { key: 'in', text: 'In stock' };
  }

  window.PFSearch = { load: load, query: query, suggest: suggest, state: S, onUpdate: function (fn) { listeners.push(fn); }, highlight: highlight, esc: esc, norm: norm, imageUrl: imageUrl, money: money, cleanTitle: cleanTitle, stockState: stockState, STOP: STOP };
})();
